// extracted by mini-css-extract-plugin
export default {"policyPage":"styles_policyPage__oZMg-","title":"styles_title__9NqZ9"};